module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("80o2N"))).then(() => module.bundle.root('1iHdE'));